import { SPB_ID } from 'shared/constants/regions';
import { isAvailableRegion, NonEmptyArray, TJsonQuery } from '../../../packages/JsonQuery';
import { IConfig } from '@cian/config/shared';

interface ICheckEarlyAccessAvailabilityParams {
  jsonQuery: TJsonQuery;
  config: IConfig;
}

/**
 * @description
 * Проверяет доступность функционала раннего доступа
 */
export const checkEarlyAccessAvailability = ({ jsonQuery, config }: ICheckEarlyAccessAvailabilityParams) => {
  const enabled = config.get<boolean>('BX.EarlyAccess.Enabled');
  const availableRegions = config.get<NonEmptyArray<number>>('BX.EarlyAccess.AvailableRegions') || [SPB_ID];

  return enabled && isAvailableRegion(availableRegions)(jsonQuery);
};
